import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { FcpIconModule } from '../fcp-icon';
import { FcpToastComponent } from './fcp-toast.component';
import { defaultToastConfig, TOAST_CONFIG_TOKEN } from './toast-config';
import { FcpButtonModule } from '../fcp-button';

@NgModule({
    imports: [CommonModule, OverlayModule, FcpIconModule, FcpButtonModule],
    declarations: [FcpToastComponent]
})
export class FcpToastModule {
    public static forRoot(config = defaultToastConfig): ModuleWithProviders<FcpToastModule> {
        return {
            ngModule: FcpToastModule,
            providers: [
                {
                    provide: TOAST_CONFIG_TOKEN,
                    useValue: { ...defaultToastConfig, ...config }
                }
            ]
        };
    }
}
